import {Dispatch} from "react";
import {PayloadAction} from "@reduxjs/toolkit";
import {ApplicationSettingsRepositoryInstance} from "../../repository/Application/ApplicationSettingsRepository";
import {PaymentConfigActionTypes} from "../../redux/PaymentConfig/PaymentConfigReducer";

/**
 * Загружает комиссию Stripe и флаг доступа к оплате картой с core (после авторизации).
 */
export async function loadPaymentClientContext(dispatch: Dispatch<PayloadAction<any>>): Promise<void> {
    const res = await ApplicationSettingsRepositoryInstance.getClientContext();
    if (!res.None) {
        const d = res.Some;
        dispatch({
            type: PaymentConfigActionTypes.SET_CLIENT_CONTEXT,
            payload: {
                stripePercentFee: Number(d.stripePercentFee),
                stripeFixedFeeUsd: Number(d.stripeFixedFeeUsd),
                stripePaymentToleranceUsd: Number(d.stripePaymentToleranceUsd),
                cardPaymentMode: d.cardPaymentMode,
                cardPaymentAllowed: Boolean(d.cardPaymentAllowed),
            },
        });
    }
}
